import CSS from "csstype";
import Swoosh from "./Swoosh";
import { Logo } from "@sgi/gravity";
import { useBreakpointValue } from "@chakra-ui/react";

export default function SideBar() {
  const justify: CSS.Properties = {
    display: "flex",
    justifyContent: "flex-end",
    minWidth: "36vw",
    minHeight: "100vh",
    position: "absolute",
    top: "0px",
    right: "0px",
    zIndex: "-1",
  };
  const test: CSS.Properties = {
    backgroundColor: "#007480",
    minWidth: "100%",
    minHeight: "100%",
  };

  const width = useBreakpointValue({
    base: "100px",
    sm: "140px",
    md: "180px",
    lg: "200px",
  });

  return (
    <div style={justify} data-testid="sidebar-test">
      <div style={test}>
        <Logo
          width={width}
          variant="grayscale"
          position="fixed"
          padding="12px 0 12px 40px"
          left="0"
        />
        <Swoosh />
      </div>
    </div>
  );
}
